/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorPatientChatModal.vue?vue&type=template&id=513e4e10"
import script from "./DoctorPatientChatModal.vue?vue&type=script&lang=js"
export * from "./DoctorPatientChatModal.vue?vue&type=script&lang=js"
import style0 from "./DoctorPatientChatModal.vue?vue&type=style&index=0&id=513e4e10&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513e4e10')) {
      api.createRecord('513e4e10', component.options)
    } else {
      api.reload('513e4e10', component.options)
    }
    module.hot.accept("./DoctorPatientChatModal.vue?vue&type=template&id=513e4e10", function () {
      api.rerender('513e4e10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/DoctorPatientChatModal.vue"
export default component.exports